module.exports = __webpack_public_path__ + "static/media/stre-down-5.14513fde.svg";